export default __webpack_public_path__ + "static/media/calendario-imagem.22c4f1bc.svg";